export const remapSnakeToTitleCase = eventName => remapAbbreviations(eventName.trim().split('_').map(word => word.substring(0, 1).toUpperCase() + word.substring(1)).join(' ').trim());
export const remapCamelToTitleCase = eventName => remapAbbreviations(splitOnUpper(eventName.trim()).map(word => word.substring(0, 1).toUpperCase() + word.substring(1)).join(' ').trim());
function splitOnUpper(str) {
  const parts = [];
  let part = [];
  Array.from(str).forEach(c => {
    if (isLowerCase(c)) {
      part.push(c);
    } else {
      parts.push(part.join('').trim());
      part = [c];
    }
  });
  parts.push(part.join('').trim());
  return parts;
  function isLowerCase(s) {
    return s === s.toLowerCase();
  }
}
function remapAbbreviations(text) {
  ['Url', 'Id', 'Faq'].forEach(abbreviation => {
    text = text.replace(` ${abbreviation}`, ` ${abbreviation.toUpperCase()}`);
  });
  return text;
}
//# sourceMappingURL=namingMapper.js.map